import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { first } from 'rxjs/internal/operators/first';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { GlobalConstants } from '../../../common/constants/global.constant';
import { CommonService } from '../../../common/services/common.service';
import { Utils } from '../../../common/utils/utils';
import { AssetLibraryConstants } from '../../../core/routing/services/asset-library/constants/asset-library.constant';
import { SegmentsService } from '../../../core/routing/services/asset-library/segments.service';
import { CreateProfileService } from '../../../core/routing/services/profile/create-profile.service';
import { environment } from 'src/environments/environment';
import { Segment, SelectedContGrpsForProfile } from '../../asset-library/segments/interfaces/segments.i';
import { ProfileRequest, ProfileUpdateResponse } from '../../create-profile/interface/profile.i';
import { ProfileStoreService } from '../../create-profile/store/profile.store';
import { Segment as deviceSegment } from '../interface/devices-interface.i';
import { DeviceStoreService } from '../store/device.store';
import { DevicesConstants } from '../../../core/routing/services/devices/constants/devices.constants';
import { GoogleAnalyticsService } from '../../../../app/modules/google-analytics/google-analytics.service';

@Component({
  selector: 'iposcen-device-segments',
  templateUrl: './device-segments.component.html',
  styleUrls: ['./device-segments.component.scss']
})
export class DeviceSegmentsComponent implements OnInit {
  @Output() readonly getSegmentStatus = new EventEmitter();
  @Output() readonly dismissFunc = new EventEmitter();
  userId = sessionStorage.getItem(GlobalConstants.USER_ID);
  userRole = sessionStorage.getItem(GlobalConstants.USER_ROLE);
  segmentsGroups: Segment[];
  displaySegmentGroups = [];
  isCollapsed: boolean = true;
  segmentHeading: string;
  presentPage: string;
  profilePage: string = GlobalConstants.PROFILE;
  selctedContGrpsForProfile: SelectedContGrpsForProfile = {
    contentGrps: [],
    showOnDevice: false
  };
  showDevice = false;
  profileDataSet: any;
  profileSegmentContentData: any;
  sortValue: string;
  pages: number;
  pageGrpForm: any;
  url = AssetLibraryConstants.S3_ASSET_LIBRARY_USERS + this.userId
    + AssetLibraryConstants.ASSET_LIBRARY_ASSET_LIBRARY + this.userId;
  deviceTypes = GlobalConstants.DEVICE_TYPES;
  manufacturers = GlobalConstants.MANUFACTURERS;
  processors = GlobalConstants.PROCESSORS;
  generation = GlobalConstants.GENERATION;
  showonDeviceDisabled = GlobalConstants.SHOW_ON_DEVICE_DISABLED;
  addToPackageLimit = GlobalConstants.SEGMENT_ADD_TO_PACKAGE_LIMIT;
  page = 1;
  pageSize = 5;
  maxSize = 5;
  activeSegmentList: any;
  cancelBtn = GlobalConstants.CANCEL;
  successMessage = DevicesConstants.DEVICE_UPDATE_SAVED;
  description = DevicesConstants.DEVICE_UPDATE_DESC;
  isCancel = false;
  buttonLabelNo = DevicesConstants.NO;
  buttonLabelCancel = DevicesConstants.CANCEL_UPDATE;
  deviceNameLabel = DevicesConstants.DEVICENAME;
  cancelLabel = GlobalConstants.CANCEL;
  saveChangesLabel = GlobalConstants.SAVE_CHANGES;
  openModalPopup = false;
  openSuccessPopup = false;
  isSelectedData = new Map();
  isSegmentEmpty: boolean;
  isdeviceSegmentNone: boolean;
  isRadioBtnSelected = false;
  globConst = GlobalConstants;
  isIdleExperienceEnabled:string = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
	isCheckedPreview: boolean;
  private ngUnsubscribe = new Subject<boolean>();

  constructor(private segmentsService: SegmentsService,
    private cmnService: CommonService,
    private profileStoreService: ProfileStoreService,
    private createProfileService: CreateProfileService,
    private deviceStore: DeviceStoreService,
    private googleAnalyticsService: GoogleAnalyticsService) { }

  ngOnInit(): void {
    this.isdeviceSegmentNone = false;
    this.isCheckedPreview = true;
    this.getAllSegmentsByUser();
  }

  getAllSegmentsByUser() {
    this.googleAnalyticsService.devieInfoTabName('Segment');
    this.prefillProfileData();
    this.presentPage = GlobalConstants.DEVICE_DASHBOARD;
    this.segmentsService.getAllSegmentsByUser()
      .pipe(takeUntil(this.ngUnsubscribe))
      .pipe(first())
      .subscribe(getAllLogoContentResponse => {

        this.segmentsGroups = (getAllLogoContentResponse.segment as Segment[]);
        this.displaySegmentGroups = [];
        this.segmentsGroups.forEach(ele => {
          ele.configurations = JSON.parse(ele.configurations);
          ele.createdByUser = (ele.createdByUser === this.userId) ? GlobalConstants.ME : ele.createdByUser;
          this.displaySegmentGroups.push(ele);
        });
        this.isSegmentEmpty = (this.displaySegmentGroups.length == 0) || false;
        this.displaySegmentGroups.forEach(element => {
          element.isExpanded = false;
          element.isIdleExperienceEnabled = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
          if (element.updateTime) {
            element.updateTime = new Date(element.updateTime).toLocaleString()
              .replace(',', '');
          }
          // if deleting make it true
          element.isDeleted = false;
          if (element && element.configurations && element.configurations.formFactor) {
            element.configurations.formFactor = Utils.getFormFactorNames(element.configurations.formFactor);
          }
          //TODO based on count
          // this.segmentHeading = this.displaySegmentGroups.length <= 1 ? 'Segment' : 'Segments';
          if (this.presentPage === GlobalConstants.PROFILE) {
            element.showOnDevice = false;
            element.addToPackage = false;
          }
             // For content expired notification
             element.isContentExpires = Utils.getExpiredUnChangedContentdata(element);
        });
        this.sortBy(GlobalConstants.CREATED_DATE);
        if (this.presentPage === this.profilePage) {
          this.displaySegmentGroups.forEach((element, index) => {
            element.index = index;
          });
          this.selctedContGrpsForProfile = {
            contentGrps: []
          };
          this.prefillProfileData();
          //TODO MULTIPLE CONDITIONS
          if (this.showDevice) {
            let logCont = this.displaySegmentGroups
              .filter(a => a.addToPackage === true)
              .sort((a, b) => new Date(a.updateTime).getTime() - new Date(b.updateTime).getTime());
            if (this.selctedContGrpsForProfile.contentGrps?.length === GlobalConstants.SEGMENT_CONTENT_GRP_MAX_IN_PACKAGE) {
              this.setPackageNshowOnDeviceVal(logCont[0].index, false);//if limit reached. set values to false since we are de-selecting
            }
            if (this.selctedContGrpsForProfile.showOnDevice) {
              this.findIndexAndSetValue(GlobalConstants.DISPLAY_SEGMENTS, GlobalConstants.ID, false);//de-select in display logo content
              this.findIndexAndSetValue(GlobalConstants.SELECTED_CONT_GRPS, GlobalConstants.SEGMENT_ID, false);//de-select in selectedCntGrps
            }
            if (this.selctedContGrpsForProfile.contentGrps?.length === GlobalConstants.SEGMENT_CONTENT_GRP_MAX_IN_PACKAGE) {//Since maximum limit reached remove the earliest created one
              this.selctedContGrpsForProfile.contentGrps = this.selctedContGrpsForProfile.contentGrps
                .filter(a => a.segmentId !== logCont[0].id);
            }
            this.displaySegmentGroups[0].addToPackage = true;// add to package/showondevice since selected yes on pop-up
            this.displaySegmentGroups[0].showOnDevice = true;
            this.pushToSelectedGrps(0);
            this.selctedContGrpsForProfile.showOnDevice = this.displaySegmentGroups[0].id;
            //update back to profile/ and profile store
            this.createProfileService.updateProfile(
              this.profileDataSet?.profileId, { segments: this.selctedContGrpsForProfile.contentGrps }
            )
              .pipe(takeUntil(this.ngUnsubscribe))
              .subscribe(data => {
                const profileUpdateResponse = data.profile as ProfileUpdateResponse;
                this.profileStoreService.updateProfileData(profileUpdateResponse);
              });
          }
        }

        const storeData = this.deviceStore.deviceStoreData?.segments;
        if (storeData?.length == 0) this.isdeviceSegmentNone = true;
        if (storeData?.length > 0) {         
            this.isSelectedData.set(storeData[0].segmentId, true);
            const checkIndex = this.displaySegmentGroups.findIndex(d => d.id === storeData[0].segmentId);
            const existData = this.displaySegmentGroups
              .filter(a => a.id === storeData[0].segmentId);
            this.displaySegmentGroups[checkIndex].showOnDevice = true;

            const segmentDataList = {
              segmentId: storeData[0].segmentId,
              showOnDevice: true
            };
            this.activeSegmentList = segmentDataList as deviceSegment;          
        }
      },
        error => {
          this.isSegmentEmpty = true;
        }
      );
  }

  findIndexAndSetValue(setValueTo: string, keyName: string, setValueAs: any) {
    if (setValueTo === GlobalConstants.DISPLAY_SEGMENTS) {
      const checkInd = this.displaySegmentGroups.findIndex(d => d[keyName] === this.selctedContGrpsForProfile.showOnDevice);
      this.displaySegmentGroups[checkInd].showOnDevice = setValueAs;
    } else {
      const checkIndContentGrps = this.selctedContGrpsForProfile.contentGrps.findIndex
        (d => d[keyName] === this.selctedContGrpsForProfile.showOnDevice);
      this.selctedContGrpsForProfile.contentGrps[checkIndContentGrps].showOnDevice = setValueAs;
    }
  }

  pushToSelectedGrps(ind: number) {
    this.selctedContGrpsForProfile.contentGrps.push({
      segmentId: this.displaySegmentGroups[ind].id,
      showOnDevice: this.displaySegmentGroups[ind].showOnDevice
    });
  }

  setPackageNshowOnDeviceVal(index: number, value: boolean) {
    this.displaySegmentGroups[index].showOnDevice = this.displaySegmentGroups[index].addToPackage = value;
  }

  prefillProfileData() {
    // for edit profile -  segment tab
    const existingProfileData = this.profileStoreService.currentWorkingProfile;
    if (existingProfileData && (existingProfileData?.profileId === this.createProfileService.getProfileId())) {
      this.profileDataSet = existingProfileData as ProfileRequest;
      this.profileSegmentContentData = this.profileDataSet.segments;
      if (this.profileSegmentContentData?.length) {
        this.selctedContGrpsForProfile = {
          contentGrps: []
        };
        this.displaySegmentGroups.forEach(a => a.showOnDevice = a.addToPackage = false);
        this.selctedContGrpsForProfile.contentGrps = this.profileSegmentContentData;
        this.selctedContGrpsForProfile.contentGrps.forEach((ele, ind) => {
          const contentIdInd = this.displaySegmentGroups.findIndex(each => each.id === ele.segmentId);
          if (contentIdInd >= 0) {
            this.displaySegmentGroups[contentIdInd].addToPackage = true;
            this.displaySegmentGroups[contentIdInd].showOnDevice = ele.showOnDevice;
            if (ele.showOnDevice) {
              this.selctedContGrpsForProfile.showOnDevice = this.displaySegmentGroups[contentIdInd].id;
            }
          }
        });
      }
    }
  }

  sortBy(sortValue: string) {
    this.page = 1;
    switch (sortValue) {
      case AssetLibraryConstants.SORT_ORDER_SEGMANT_NAME: {
        this.sortValue = AssetLibraryConstants.SORT_ORDER_SEGMANT_NAME_LABEL;
        this.displaySegmentGroups.sort((segment1, segment2) =>
          segment1.configurations.publishedName.localeCompare(segment2.configurations.publishedName));
        break;
      }
      case AssetLibraryConstants.SORT_ORDER_RETAILER_NAME: {
        this.sortValue = AssetLibraryConstants.SORT_ORDER_RETAILER_NAME_LABEL;
        this.displaySegmentGroups.sort((segment1, segment2) =>
          segment1.configurations.retailerName.localeCompare(segment2.configurations.retailerName));
        break;
      }
      case GlobalConstants.CREATED_DATE: {
        this.displaySegmentGroups.sort((segment1, segment2) =>
          new Date(segment2.updateTime)?.getTime() - new Date(segment1.updateTime)?.getTime());
        break;
      }
      default:
        break;
    }
  }

  addToProfile(eventObj: any, index: number, eventSource: string) {
    if (eventSource === GlobalConstants.RADIO) {
      this.findIndexAndSetValue(GlobalConstants.DISPLAY_SEGMENTS, GlobalConstants.ID, false);
      this.displaySegmentGroups[index].showOnDevice = true;
      this.selctedContGrpsForProfile.showOnDevice = this.displaySegmentGroups[index].id;
    }
  }

  loadMiniPreview(gId: string, pageContent: any) {
    this.pageGrpForm = {
      bgcolor: pageContent ? pageContent.bgColor : '#0068B5',
      heading: pageContent ? pageContent.title : '',
      hcolor: pageContent ? pageContent.titleFontColor : '#ffffff',
      body: pageContent ? pageContent.bodyCopy : '',
      bcolor: pageContent ? pageContent.bodyCopyFontColor : '#ffffff',
      size: pageContent ? this.getFontSize(pageContent.bodyCopyFontSize) : GlobalConstants.MEDIUM,
      media: {
        url: (pageContent && pageContent.linkedAsset) ?
          environment.apiBaseUrlAsset + this.url + AssetLibraryConstants.SEGMENTS + AssetLibraryConstants.SLASH +
          gId + AssetLibraryConstants.SLASH + pageContent.pageNum.toString() : '',
        name: '',
        format: (pageContent && pageContent.linkedAsset) ? (pageContent.linkedAssetFileType) ? pageContent.linkedAssetFileType : '' : '',
        fileObj: ''
      },
      id: gId,    // adding created group id,
      layout: pageContent ? this.getUILayoutIDByName(pageContent.UiLayout) : 1,
      previewType: pageContent ? pageContent.previewType : '',
      idleExpFullscreenEnabled: pageContent ? pageContent.idleExpFullscreenEnabled : '',
      fullScreenCheckbox: pageContent ? pageContent?.fullScreenCheckbox ? 
      pageContent.fullScreenCheckbox : false : true,
    };

    return this.pageGrpForm;
  }

  getFontSize(size) {
    if (size === GlobalConstants.NUMBER_12) { return GlobalConstants.SMALL; }
    if (size === GlobalConstants.NUMBER_14) { return GlobalConstants.MEDIUM; }
    if (size === GlobalConstants.NUMBER_16) { return GlobalConstants.LARGE; }
  }
  getUILayoutIDByName(name: string) {
    if (name === GlobalConstants.TWO_COL_RIGHT_ASSET) {
      return 1;
    } else if (name === GlobalConstants.TWO_COL_LEFT_ASSET) {
      return 2;
    } else if (name === GlobalConstants.ONE_COL_MID_ASSET) {
      return 3;
    }
  }

  getDetailsOfSegment(id: string) {
    this.displaySegmentGroups.forEach(element => {
      if (element.id === id) {
        element.isExpanded = !element.isExpanded;
        element.isIdleExperienceEnabled = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
        this.cmnService.scrollToBottom(id);
      }
    });
    this.isIdleExperienceEnabled = GlobalConstants.LIVE_PREVIEW_PREVIEW_TAB_IPOS;
  }
  removeShowonDeveice() {
    this.isRadioBtnSelected = true;
    this.activeSegmentList = [];
    this.isSelectedData.clear();
  }

  addShowonDeveice(event, index, item) {
    this.isRadioBtnSelected = true;
    this.isSelectedData.clear();
    this.isSelectedData.set(item.id, true);

    let segmentList = {
      segmentId: '',
      showOnDevice: false
    };
    this.displaySegmentGroups.forEach(element => {
      if (element.id === item.id) {
        segmentList.segmentId = item.id;
        segmentList.showOnDevice = true;
      }
    });
    this.activeSegmentList = segmentList as deviceSegment;
  }

  saveSegmentChange() {
    this.googleAnalyticsService.devieInfoChangesSaved('Segment');
    if (this.activeSegmentList) {
      this.successMessage = DevicesConstants.DEVICE_UPDATE_SAVED;
      this.description = DevicesConstants.DEVICE_UPDATE_DESC;
      this.openSuccessPopup = true;
      this.getSegmentStatus.emit(true);
      this.deviceStore.updateDeviceData({ segments: !(this.activeSegmentList.segmentId === undefined) ? [this.activeSegmentList] : [] });
    } else {
      this.deviceStore.updateDeviceData({ segments: undefined });
      this.getSegmentStatus.emit(false);
    }
  }
  cancel() {
    this.successMessage = DevicesConstants.DEVICE_CANCEL_TITLE;
    this.description = DevicesConstants.DEVICE_CANCEL_DESC;
    this.isCancel = true;
    this.openModalPopup = !this.openModalPopup;
  }

  closeModal() {
    this.openModalPopup = false;
  }

  dismiss() {
    this.dismissFunc.emit('');
    this.openModalPopup = !this.openModalPopup;
    this.isCancel = false;
  }

  closeSuccessModal() {
    this.openSuccessPopup = false;
  }

  togglePreviewTabs(previewType, id) {
    this.isIdleExperienceEnabled = previewType;
    this.displaySegmentGroups.forEach(element => {
      if (element.id === id) {
        element.isIdleExperienceEnabled = this.isIdleExperienceEnabled;
      }
    });
  }
}
